<template>
  <div>
    <div v-if="generalInfo && generalInfo.contact_message" class="contact-banner">
      {{ generalInfo.contact_message }}
    </div>
  <v-container class="my-5 px-10 contact-container">
    <div class="bpg-page-heading">
      <h1>Contact Us</h1>
    </div>
    <div v-if="!submitted" class="bpg-page-subheading mt-4">
      <h2>To help speed our response to your question, please select the appropriate topic from the dropdown to ensure that your question is directed to the appropriate Baker staff for an expedited reply.</h2>
    </div>
    <v-form v-if="!submitted" v-model="valid" class="my-6 mt-sm-12">
      <base-select
              v-model="form.supportEmails"
              :items="contactList"
              value="Placing an order"
              item-text="organization"
              item-value="contacts"
              required
            />
      <v-row>
        <v-col cols="12" sm="6">
          <base-input v-model="form.firstName" label="First Name" required />
        </v-col>
        <v-col cols="12" sm="6">
          <base-input v-model="form.lastName" label="Last Name" required />
        </v-col>
        <v-col cols="12" sm="6">
          <base-input v-model="form.email" label="Email" email required />
        </v-col>
        <v-col cols="12" sm="6">
          <base-input v-model="form.phone" label="Phone" :mask="{ mask: '(000)-000-0000' }" />
        </v-col>
      </v-row>

      <base-textarea v-model="form.message" label="Message" required />

      <div class="d-flex justify-space-around">
        <base-button :disabled="!valid" text="Submit" uppercase :loading="submitting" @click="submit()" />
      </div>
    </v-form>
    <div v-if="submitted" class="mt-6 mt-sm-12 text-center">
      <h2 class="mb-4 font-large">
        Thank you for getting in touch!
      </h2>
      <p class="font-default-size">
        We appreciate you contacting us. Someone from our team will be in touch with you soon.
      </p>
      <p class="font-default-size">
        Have a great day!
      </p>
    </div>
    <p v-if="error" class="warning--text font-default-size">
      {{ error }}
    </p>
  </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import prismicAPI from '@/helpers/prismic-api'

export default {
  name: 'Contact',
  head () {
    return {
      title: 'Contact'
    }
  },
  data: () => {
    return {
      supportGroup: {
        emails: ''
      },
      form: {
        message: ''
      },
      valid: false,
      submitting: false,
      submitted: false,
      error: null
    }
  },
  async asyncData ({ params, error }) {
    try {
      const data = { contactList: [] }
      const contactTopic = params.uuid
      // 'order-faq-contact'
      const result = await prismicAPI.getByUID('support-groups', contactTopic)
      if (!result || !result.document) {
        error({ statusCode: 404, message: 'Contact form not found' })
        return
      }
      if (result.document.body) {
        result.document.body.forEach((p) => {
          if (p.slice_type === "contact_group") {
            data.contactList.push({ organization: p.primary.support_group_name, contacts: p.items })
          }
        })
      }
      return data
    } catch (e) {
      error({ statusCode: 404, message: 'Contact form not found' })
    }
  },
  computed: {
    ...mapState({
      generalInfo: state => state.layout.generalInfo
    })
  },
  methods: {
    submit () {
      this.submitting = true
      this.error = null
      return this.$axios.post('store/contact', this.form)
        .then(() => {
          this.submitted = true
        })
        .catch((err) => {
          this.error = err.isChapterException && err.isUserFriendly ? err.message
            : 'Error submitting contact information. Please try again.'
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './scss/variables';
  .contact-banner {
    background-color: $very-light-blue;
    height: 4.8em;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-transform: uppercase;
  }
  .contact-container {
    max-width: 800px;
  }

  .row > div {
    padding-top: 0;
    padding-bottom: 5px;
  }

  address {
    font-style: normal;
  }
</style>
